import { Component, OnInit, ViewChild } from '@angular/core';
import { SubZoneTitleService, ZoneService, TitleService, CenterService, BaseService } from '../../../mesc/mesc.service';
import { SubZoneTitle } from '../../../../shared/model';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { BaseGridTemplate } from '../../../../shared/cgp-grid/base-cgp-grid.template';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';
import {
  TntToolService
}
  from '../../tnt.service';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-zone-sub-zone-title',
  templateUrl: './zone-sub-zone-title.component.html',
  host: { 'style': 'width: 100%' },
})
export class ZoneSubZoneTitleComponent extends BaseGridTemplate implements OnInit {
  @ViewChild('combo') public combo: ComboBoxComponent;

  constructor(
    public zoneService: ZoneService,
    public baseService: BaseService,
    private SubZoneTitleService: SubZoneTitleService,
    private TitleService: TitleService,
    private TntToolService: TntToolService,
    private CgpAlertDialogService: CgpAlertDialogService,
    private centerService: CenterService,
    private cgpSnackbarService: CgpSnackbarService
  ) { super(); }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;


  isNew: boolean = false;
  editDataItem: SubZoneTitle;
  selectedSubZone: any = undefined;
  selectedCenter: any = undefined;
  allZones: any[];
  zones: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  selectedZone: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  zonesByCenter: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  ngOnInit(): void {
    this.SubZoneTitleService.subscribe(data => data.map(x => x.Description = x.Zone + ' - ' + x.ZoneDescription))

    this.TitleService.query();
    this.centerService.query();
    this.SubZoneTitleService.read("", true)
      .then(() => {
        let subZoneTitles: any[] = this.SubZoneTitleService.data;

        let unique: any[] = [];
        let uniqueZones: any[] = subZoneTitles.filter(x => {
          if (!unique.some(u => u === x.ZoneId)) {
            unique.push(x.ZoneId);
            return true;
          }
          return false;
        })
        this.allZones = uniqueZones;
        this.zones.next(uniqueZones);

      })
  }


  CountHandler() {
    this.setModelHandler();
  }


  handleFilter(value: any) {
    let check: string = value.toString();
    let result = this.allZones
      .filter(x => {
        try {
          let source: string = x['Description'].toString().toLowerCase();
          return source.indexOf(check.toLowerCase()) !== -1;
        } catch (e) { }
      });
    this.zones.next(result);
  }

  handleRead = () => {
    return this.selectedZone.value ?
      this.baseService.read(this.selectedZone.value['ZoneId'] + '/subzonetitle', true) :
      this.baseService.read("SubZoneTitle", true);
  }

  handleError = (error: any) => {
    var self = this;
    if (error.status == '500') {
      self.CgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'Cannot de-active ZoneSubZoneTitle because it is associated with a CAMTL System and/or TNT Tool.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
  }

  handleSave = (dataItem, isNew) => {
    var self = this;

    this.SubZoneTitleService.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.grid.refresh();
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        })
      })
      .catch(this.handleError);
  }

  ZoneSubZoneCount = (e, dataItem) => {
    var self = this;
    self.TntToolService.service.read('/' + dataItem.ZoneId + '/' + dataItem.SubZoneId + '/toolcount', true).then(function (response) {
      self.CgpAlertDialogService.showAlertDialog({
        title: 'Zone Sub-Zone Count',
        message: response + ' tool/tools assigned to ' + 'Zone: ' + dataItem.Zone + ' , SubZone: ' + dataItem.SubZone,
        alert: '',
        closeLabel: 'Close',
      })
    });

  }

  TitleCount = (e, dataItem) => {
    var self = this;
    self.TntToolService.service.read('/' + dataItem.TitleId + '/toolcount', true).then(function (response) {
      self.CgpAlertDialogService.showAlertDialog({
        title: 'Title Count',
        message: response + ' tool/tools assigned to ' + dataItem.Title,
        alert: '',
        closeLabel: 'Close',
      })
    });
  }


  handleCenterChange = (value) => {
    this.selectedCenter = value;
    if (!value) {
      this.editForm.get("ZoneId").setValue(undefined);
      this.editForm.get("ZoneId").disable();
      this.editForm.get("SubZoneId").setValue(undefined);
      this.editForm.get("SubZoneId").disable();
    } else {
      this.editForm.get("ZoneId").enable();
      let zonesByCenter: any[] = this.allZones.filter(x => (x.CenterId === value))
      this.zoneService.next(zonesByCenter);
    }
  }

  handleZoneFilter = (value) => {
    this.selectedZone.next(value);
    this.grid.resetState();
  }


  /**
   * If zoneId is defined, query for SubZones under that Zone
   * otherwise reset Zones service to an empty list
   */
  handleZoneChange = (value) => {
    const subZoneCtrl = this.editForm.get('SubZoneId');
    if (!subZoneCtrl) return;

    if (value) {
      this.baseService.read(`SubZone/Zone/${value}`, true);
      subZoneCtrl.enable();
    } else {
      subZoneCtrl.reset();
      subZoneCtrl.disable();
    }
  }


  presetComboboxes() {
    this.handleCenterChange(this.editDataItem.CenterId);
    this.handleZoneChange(this.editDataItem.ZoneId);
  }

  setModelHandler() {
    this.editDataItem = new SubZoneTitle();
    this.presetComboboxes();
    this.editDataItem.IsActive = true;
  }

  handleEdit = (dataItem) => {
    this.editDataItem = dataItem;
    this.presetComboboxes();
  }

  editForm = new FormGroup({
    CenterId: new FormControl("", Validators.required),
    ZoneId: new FormControl("", Validators.required),
    SubZoneId: new FormControl({ value: "", disabled: true }, Validators.required),
    TitleId: new FormControl("", Validators.required),
    BodySectionId: new FormControl(),
    Id: new FormControl(),
    IsActive: new FormControl()
  });

  columns: any[] =
    [{
      field: 'Zone',
      title: 'Zone',
      width: 100,
    },
    {
      field: 'ZoneDescription',
      title: 'Zone Description',
      width: 320,
    },
    {
      field: 'CenterDescription',
      title: 'Center'
    },
    {
      field: 'SubZone',
      title: 'Sub Zone',
      width: 100,
    },
    {
      field: 'LidNumber',
      title: 'LID #',
      width: 120,
    },
    {
      field: 'Title',
      title: 'Title',
      width: 320
    },
    {
      field: "IsActive",
      title: "Status",
      width: "120",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    }]

  CustomButtons = [
    {
      id: "ZoneSubZoneCount",
      class: "fa fa-object-group",
      callback: this.ZoneSubZoneCount,
      title: 'Zone/SubZone Tool Count'
    },
    {
      id: "TitleCount",
      class: "fa fa-sticky-note",
      callback: this.TitleCount,
      title: 'Title Tool Count'
    }
  ];

  template = {
    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: true,
      width: 150,
      custom: this.CustomButtons
    },
    columns: this.columns,
    read: this.handleRead,
    edit: this.handleEdit,
    save: this.handleSave,
    service: this.zoneService,
    fileName: 'zone_subzone_title.xlsx'
  }

  formDialog = {
    title: "Zone-SubZone-Title Association",
    formControls: [
      {
        type: "combobox",
        readonly: "update",
        name: "CenterId",
        title: "Center",
        textField: "Description",
        valueField: "Id",
        placeholder: "Select Center...",
        onChange: this.handleCenterChange,
        service: this.centerService
      },
      {
        type: "combobox",
        readonly: "update",
        name: "ZoneId",
        title: "Zone",
        textField: "Description",
        valueField: "ZoneId",
        placeholder: "Select Zone...",
        onChange: this.handleZoneChange,
        service: this.zoneService
      },
      {
        type: "combobox",
        readonly: "update",
        name: "SubZoneId",
        title: "Sub Zone",
        textField: "Description",
        valueField: "Id",
        placeholder: "Select SubZone...",
        service: this.baseService
      },
      {
        type: "combobox",
        //readonly: "update",
        name: "TitleId",
        title: "Lid Number",
        textField: "LidNumber",
        valueField: "Id",
        placeholder: "Select Lid Number...",
        service: this.TitleService
      },
      {
        type: "value",
        name: "TitleId",
        title: "Title",
        pipe: 'filter',
        field: "Description",
        check: "Id",
        service: this.TitleService
      },
      {
        type: "boolean",
        name: "IsActive",
        title: "Active",
      }
    ],
  }
}
